/* Lapis Magica UI (2026 redesign): theme toggle, mega menu, mobile drawer,
   card add-to-cart, shuffle rows, wishlist header label. No dependencies. */
(function () {
  'use strict';
  var root = document.documentElement;

  /* ---------- light / dark ---------- */
  function syncThemeLabels() {
    var dark = root.getAttribute('data-theme') === 'dark';
    document.querySelectorAll('[data-lm-theme-toggle]').forEach(function (b) {
      var label = b.querySelector('[data-lm-theme-label]');
      if (label) label.textContent = dark ? b.dataset.labelLight : b.dataset.labelDark;
      b.setAttribute('aria-pressed', dark ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lm-theme-toggle]');
    if (!b) return;
    var next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    root.setAttribute('data-theme', next);
    try { localStorage.setItem('lm-theme', next); } catch (err) {}
    syncThemeLabels();
  });

  /* ---------- mega menu ---------- */
  function initMega() {
    var nav = document.querySelector('[data-lm-nav]');
    if (!nav) return;
    var items = Array.prototype.slice.call(nav.querySelectorAll('[data-lm-item]'));
    var openItem = null, openTimer = null, closeTimer = null;
    var canHover = window.matchMedia('(hover: hover)').matches;

    function setOpen(item, focusFirst) {
      if (openItem && openItem !== item) {
        openItem.classList.remove('is-open');
        var ob = openItem.querySelector('.lm-nav__top');
        if (ob) ob.setAttribute('aria-expanded', 'false');
      }
      openItem = item;
      if (!item) return;
      item.classList.add('is-open');
      var btn = item.querySelector('.lm-nav__top');
      btn.setAttribute('aria-expanded', 'true');
      if (focusFirst) {
        var a = item.querySelector('.lm-mega a');
        if (a) a.focus();
      }
    }
    function closeAll() { clearTimeout(openTimer); setOpen(null); }

    items.forEach(function (item) {
      var btn = item.querySelector('button.lm-nav__top');
      if (!btn) return;
      btn.addEventListener('click', function () {
        clearTimeout(openTimer);
        if (openItem === item) closeAll(); else setOpen(item);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); setOpen(item, true); }
      });
      if (canHover) {
        item.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer); clearTimeout(openTimer);
          if (openItem && openItem !== item) setOpen(item);
          else if (!openItem) openTimer = setTimeout(function () { setOpen(item); }, 150);
        });
        item.addEventListener('mouseleave', function () {
          clearTimeout(openTimer);
          closeTimer = setTimeout(function () { if (openItem === item) closeAll(); }, 120);
        });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !openItem) return;
      var btn = openItem.querySelector('.lm-nav__top');
      closeAll();
      if (btn) btn.focus();
    });
    document.addEventListener('click', function (e) {
      if (openItem && !e.target.closest('[data-lm-nav]')) closeAll();
    });
    nav.addEventListener('focusout', function (e) {
      if (openItem && !nav.contains(e.relatedTarget)) closeAll();
    });
  }

  /* ---------- mobile drawer ---------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-lm-drawer]');
    if (!drawer) return;
    var opener = document.querySelector('[data-lm-drawer-open]');
    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var c = drawer.querySelector('.lm-drawer__close');
      if (c) c.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
      document.body.style.overflow = '';
    }
    if (opener) opener.addEventListener('click', open);
    drawer.querySelectorAll('[data-lm-drawer-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
  }

  /* ---------- search placeholder: shorter on phones ---------- */
  function initSearch() {
    var input = document.getElementById('LmSearch');
    if (!input || !input.dataset.placeholderShort) return;
    var long = input.getAttribute('placeholder');
    var mq = window.matchMedia('(max-width: 989px)');
    function apply() { input.setAttribute('placeholder', mq.matches ? input.dataset.placeholderShort : long); }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
  }

  /* ---------- card add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-lm-atc]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
    btn.setAttribute('aria-disabled', 'true');
    var notification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var fd = new FormData(form);
    if (notification && notification.getSectionsToRender) {
      fd.append('sections', notification.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
      notification.setActiveElement && notification.setActiveElement(btn);
    } else {
      fd.append('sections', 'cart-icon-bubble');
    }
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { alert(res.description || res.message); return; }
        if (notification && notification.renderContents) {
          notification.renderContents(res);
        } else if (res.sections && res.sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          var doc = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
          var sec = doc.querySelector('.shopify-section');
          if (bubble && sec) bubble.innerHTML = sec.innerHTML;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lm-card', productVariantId: fd.get('id'), cartData: res });
        }
        var old = btn.innerHTML;
        btn.classList.add('is-added');
        btn.textContent = btn.dataset.added || 'Added';
        setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = old; }, 1800);
      })
      .catch(function (err) { console.error(err); })
      .finally(function () { btn.removeAttribute('aria-disabled'); });
  });

  /* ---------- random rows: random in-stock products from the whole collection ---------- */
  function initRandom() {
    var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/+$/, '');
    document.querySelectorAll('[data-lm-random]').forEach(function (list) {
      var handle = list.dataset.lmRandom, count = parseInt(list.dataset.count, 10) || 4;
      fetch('/collections/' + handle + '.json')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (meta) {
          var total = (meta && meta.collection && meta.collection.products_count) || 0;
          if (!total) return null;
          var pages = Math.ceil(total / 250), picks = [], tries = Math.min(2, pages), jobs = [];
          while (picks.length < tries) { var pg = 1 + Math.floor(Math.random() * pages); if (picks.indexOf(pg) < 0) picks.push(pg); }
          picks.forEach(function (pg) {
            jobs.push(fetch('/collections/' + handle + '/products.json?limit=250&page=' + pg).then(function (r) { return r.ok ? r.json() : { products: [] }; }));
          });
          return Promise.all(jobs);
        })
        .then(function (res) {
          if (!res) return;
          var pool = [];
          res.forEach(function (j) { pool = pool.concat((j.products || []).filter(function (p) { return p.variants && p.variants.some(function (v) { return v.available; }); })); });
          for (var i = pool.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = pool[i]; pool[i] = pool[j]; pool[j] = t; }
          var chosen = pool.slice(0, count + 2);
          return Promise.all(chosen.map(function (p) {
            return fetch(root + '/products/' + p.handle + '?view=lm-card')
              .then(function (r) { return r.ok && !r.redirected ? r.text() : ''; })
              .then(function (html) { return /<\s*(?:!doctype|html|body)\b/i.test(html) ? '' : html.trim(); })
              .catch(function () { return ''; });
          }));
        })
        .then(function (cards) {
          if (!cards) return;
          cards = cards.filter(function (h) { return h.indexOf('lm-card') > -1; }).slice(0, count);
          if (cards.length < count) return;
          list.innerHTML = cards.map(function (h) { return '<li>' + h + '</li>'; }).join('');
        })
        .catch(function (err) { console.error(err); });
    });
  }

  /* ---------- shuffle rows ---------- */
  function initShuffle() {
    document.querySelectorAll('[data-lm-shuffle]').forEach(function (list) {
      var show = parseInt(list.dataset.lmShuffle, 10) || 4;
      var lis = Array.prototype.slice.call(list.children).filter(function (li) { return li.querySelector('.lm-card'); });
      for (var i = lis.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = lis[i]; lis[i] = lis[j]; lis[j] = t;
      }
      lis.forEach(function (li, k) { li.hidden = k >= show; list.appendChild(li); });
    });
  }

  /* ---------- wishlist app header link: add our text label ---------- */
  function initWish() {
    var slot = document.querySelector('[data-lm-wish]');
    if (!slot) return;
    function label() {
      var a = slot.querySelector('.Vtl-WishlistHeader');
      if (a && !a.dataset.lmLabel) a.setAttribute('data-lm-label', slot.dataset.label || 'Wishlist');
    }
    label();
    new MutationObserver(label).observe(slot, { childList: true, subtree: true });
  }


  /* ---------- side contents: which heading is being read ----------
     tops: the headings' viewport tops, in page order; thr: the line under the sticky header.
     A heading counts once it passes thr. Headings near the foot of the page can never get there,
     so their turns are spread over the scroll that is left: the last one is marked at the bottom.
     (sections/lm-faq.liquid has a copy for its inline script.) */
  function spyPick(tops, thr) {
    var y = window.scrollY, max = document.documentElement.scrollHeight - window.innerHeight;
    var at = tops.map(function (t) { return t + y - thr; });
    var n = at.length, k = -1, i;
    for (i = 0; i < n; i++) { if (at[i] > max) { k = i; break; } }
    if (k > -1) {
      var s0 = k > 0 ? Math.min(Math.max(at[k - 1], 0), max) : 0;
      for (i = k; i < n; i++) at[i] = s0 + (max - s0) * (i - k + 1) / (n - k);
    }
    var cur = 0;
    for (i = 0; i < n; i++) { if (y >= at[i] - 1) cur = i; }
    return cur;
  }

  /* ---------- collection page: filters, sort, pagination (Section Rendering API) ---------- */
  function collRoot() { return document.getElementById('LmCollection'); }

  function buildCollectionUrl(base) {
    var root = collRoot();
    var params = new URLSearchParams();
    var top = root.querySelector('[data-lm-topbar]');
    var side = root.querySelector('[data-lm-sideform]');
    var seen = {};
    [top, side].forEach(function (form) {
      if (!form) return;
      new FormData(form).forEach(function (v, k) {
        if (v === '' || v == null) return;
        var key = k + '=' + v;
        if (seen[key]) return;
        seen[key] = 1;
        params.append(k, v);
      });
    });
    // the sidebar owns its own filters: drop hidden copies in the top form that the sidebar unchecked
    if (side) {
      var sideNames = {};
      side.querySelectorAll('input[name]').forEach(function (i) { sideNames[i.name] = 1; });
      var clean = new URLSearchParams();
      params.forEach(function (v, k) {
        if (sideNames[k]) {
          var inSide = Array.prototype.some.call(side.querySelectorAll('input[name="' + CSS.escape(k) + '"]'), function (i) {
            return (i.type === 'checkbox' ? i.checked : i.value !== '') && i.value === v;
          });
          if (!inSide) return;
        }
        clean.append(k, v);
      });
      params = clean;
    }
    var sort = root.querySelector('[data-lm-sort]');
    if (sort) { params.delete('sort_by'); if (sort.value) params.set('sort_by', sort.value); }
    var qs = params.toString();
    return base + (qs ? '?' + qs : '');
  }

  function loadCollection(url, opts) {
    opts = opts || {};
    var root = collRoot();
    if (!root) { location.href = url; return; }
    var sid = root.dataset.sectionId;
    root.classList.add('is-loading');
    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid);
    fetch(fetchUrl)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.getElementById('LmCollection');
        if (!next) { location.href = url; return; }
        var sideOpen = root.querySelector('[data-lm-side]') && root.querySelector('[data-lm-side]').classList.contains('is-open');
        // swap the parts separately so apps watching #ProductGridContainer see a normal content update
        ['#LmTopBar', '#LmUvPick', '[data-lm-side]', '#ProductGridContainer'].forEach(function (sel) {
          var a = root.querySelector(sel), b = next.querySelector(sel);
          if (a && b) a.innerHTML = b.innerHTML;
        });
        if (sideOpen) root.querySelector('[data-lm-side]').classList.add('is-open');
        var tbf = root.querySelector('#LmTopBar'), tbb = tbf && tbf.querySelector('[data-lm-topbar-toggle]');
        if (tbb) tbb.setAttribute('aria-expanded', tbf.classList.contains('is-open') ? 'true' : 'false');
        if (!opts.replace) history.pushState({ lmColl: 1 }, '', url);
        if (opts.scrollTop) {
          var y = root.querySelector('#ProductGridContainer').getBoundingClientRect().top + window.scrollY - 90;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
        document.dispatchEvent(new CustomEvent('lm:collection-updated'));
      })
      .catch(function () { location.href = url; })
      .finally(function () { root.classList.remove('is-loading'); });
  }

  // top bar: a picked value applies at once (the submit button exists only in <noscript>)
  function applyTopbar(top) {
    var root = collRoot();
    var stone = top.querySelector('[data-lm-stone]');
    var base = root.dataset.collectionUrl;
    var target = stone ? stone.value : base;
    var url = buildCollectionUrl(target.split('?')[0]);
    if (stone && target.split('?')[0] !== base) { location.href = url; return; }
    loadCollection(url);
  }

  document.addEventListener('submit', function (e) {
    var top = e.target.closest && e.target.closest('[data-lm-topbar]');
    if (!top) return;
    e.preventDefault();
    applyTopbar(top);
  });

  var sideTimer;
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!collRoot()) return;
    if (t.closest('[data-lm-sideform]')) {
      clearTimeout(sideTimer);
      var delay = t.type === 'number' ? 600 : 0;
      sideTimer = setTimeout(function () { loadCollection(buildCollectionUrl(collRoot().dataset.collectionUrl)); }, delay);
    } else if (t.matches('select') && t.closest('[data-lm-topbar]')) {
      applyTopbar(t.closest('[data-lm-topbar]'));
    } else if (t.matches('[data-lm-sort]')) {
      loadCollection(buildCollectionUrl(collRoot().dataset.collectionUrl));
    }
  });

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-lm-ajax]');
    if (a && collRoot()) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      loadCollection(a.href, { scrollTop: a.hasAttribute('data-lm-top') });
      return;
    }
    var uvN = e.target.closest('[data-lm-uvnav]');
    if (uvN) {
      // UV photo filter: reload with ?view=uv365|uv310|uv255 (templates/collection.uvXXX.json),
      // keeping the current filters and sort (the picker's links carry only the view)
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      var uu = new URL(location.href), w = uvN.getAttribute('data-lm-uvnav');
      if (w === 'day') uu.searchParams.delete('view'); else uu.searchParams.set('view', 'uv' + w);
      uu.searchParams.delete('page');
      uu.searchParams.delete('uvp');
      location.href = uu.toString();
      return;
    }
    var saleT = e.target.closest('[data-lm-sale-toggle]');
    if (saleT) {
      var u = new URL(location.href);
      if (saleT.getAttribute('aria-checked') === 'true') u.searchParams.delete('view'); else u.searchParams.set('view', 'onsale');
      u.searchParams.delete('page');
      u.searchParams.delete('uvp');
      location.href = u.toString();
      return;
    }
    var tbt = e.target.closest('[data-lm-topbar-toggle]');
    if (tbt) {
      var tb = tbt.closest('[data-lm-topbar]');
      var isOpen = tb.classList.toggle('is-open');
      tbt.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      return;
    }
    var open = e.target.closest('[data-lm-side-open]');
    if (open) { var s = document.querySelector('[data-lm-side]'); if (s) { s.classList.add('is-open'); document.body.style.overflow = 'hidden'; } return; }
    var close = e.target.closest('[data-lm-side-close]');
    if (close) { var s2 = document.querySelector('[data-lm-side]'); if (s2) { s2.classList.remove('is-open'); document.body.style.overflow = ''; } }
  });
  window.addEventListener('popstate', function () { if (collRoot()) loadCollection(location.href, { replace: true }); });

  /* ---------- product page: gallery, zoom, tabs, variant, quantity ---------- */
  document.addEventListener('click', function (e) {
    var th = e.target.closest('.lm-gal__thumb');
    if (th) {
      var gal = th.closest('[data-lm-gallery]');
      var i = th.dataset.i;
      gal.querySelectorAll('.lm-gal__slide').forEach(function (s) {
        var on = s.dataset.i === i;
        s.hidden = !on;
        if (!on) s.querySelectorAll('video').forEach(function (v) { v.pause(); });
      });
      gal.querySelectorAll('.lm-gal__thumb').forEach(function (b) {
        var on = b === th;
        b.classList.toggle('is-active', on);
        if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
      return;
    }
    var z = e.target.closest('[data-lm-zoom]');
    if (z) {
      var dlg = document.querySelector('[data-lm-zoomdlg]');
      if (dlg && dlg.showModal) { dlg.querySelector('img').src = z.dataset.lmZoom; dlg.showModal(); }
      return;
    }
    if (e.target.closest('[data-lm-zoomclose]') || e.target.matches('[data-lm-zoomdlg]')) {
      var d = document.querySelector('[data-lm-zoomdlg]'); if (d) d.close();
      return;
    }
    var tab = e.target.closest('.lm-tabs [role="tab"]');
    if (tab) { selectTab(tab); return; }
    var q = e.target.closest('[data-lm-qty]');
    if (q) {
      var inp = q.parentElement.querySelector('input');
      var max = parseInt(inp.max, 10) || 99;
      inp.value = Math.min(max, Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(q.dataset.lmQty, 10)));
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  function selectTab(tab) {
    var list = tab.closest('[role="tablist"]');
    list.querySelectorAll('[role="tab"]').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var p = document.getElementById(t.getAttribute('aria-controls'));
      if (p) p.hidden = !on;
    });
    tab.focus();
  }
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('.lm-tabs [role="tab"]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var tabs = Array.prototype.slice.call(tab.parentElement.querySelectorAll('[role="tab"]'));
    var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
    selectTab(tabs[(i + tabs.length) % tabs.length]);
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-lm-variant]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var form = document.getElementById(sel.getAttribute('form'));
    if (form) {
      var idInput = form.querySelector('input[name="id"]');
      idInput.value = sel.value;
      idInput.disabled = opt.dataset.available !== 'true';
      var btn = form.querySelector('.product-form__submit');
      if (btn) btn.disabled = opt.dataset.available !== 'true';
    }
    var price = document.querySelector('[data-lm-pdp] [data-lm-price]');
    if (price) price.textContent = opt.dataset.price;
    var sku = document.querySelector('[data-lm-pdp] [data-lm-sku]');
    if (sku) { sku.textContent = opt.dataset.sku || ''; sku.parentNode.hidden = !opt.dataset.sku; }
    var u = new URL(location.href); u.searchParams.set('variant', sel.value); history.replaceState({}, '', u);
  });


  /* ---------- policy pages: numbered side nav from the h2 headings, copy-form button ---------- */
  function initPolicy() {
    var cont = document.querySelector('.shopify-policy__container');
    if (!cont || cont.dataset.lm) return;
    cont.dataset.lm = '1';
    var rte = cont.querySelector('.shopify-policy__body .rte') || cont.querySelector('.shopify-policy__body');
    if (!rte) return;
    var t = window.lmPolicy || {};
    var bg = document.documentElement.lang === 'bg';
    var heads = Array.prototype.slice.call(rte.querySelectorAll(':scope > h2'));
    cont.classList.add('lm-ui', 'lm-policy');
    var layout = document.createElement('div');
    layout.className = 'lm-wrap lm-policy__layout';
    var main = document.createElement('div');
    main.className = 'lm-policy__main rte';
    if (heads.length > 2) {
      var nav = document.createElement('nav');
      nav.className = 'lm-side-nav lm-policy__nav';
      nav.innerHTML = '<p class="lm-side-nav__l">' + (t.nav || 'Contents') + '</p><ol></ol>';
      var ol = nav.querySelector('ol');
      heads.forEach(function (h, i) {
        if (!h.id) h.id = 'policy-' + (i + 1);
        var m = h.textContent.trim().match(/^(\d+)\.\s*(.*)$/);
        var num = m ? m[1] : String(i + 1);
        var label = m ? m[2] : h.textContent.trim();
        h.innerHTML = '<span class="lm-policy__num">' + (num.length < 2 ? '0' + num : num) + '</span>' + label;
        var li = document.createElement('li');
        li.innerHTML = '<a href="#' + h.id + '"><span class="lm-side-nav__n">' + (num.length < 2 ? '0' + num : num) + '</span>' + label + '</a>';
        ol.appendChild(li);
        // copy button on the model withdrawal form section
        if (/withdrawal form|формуляр за отказ|образец/i.test(label)) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'lm-pill lm-policy__copy';
          btn.textContent = bg ? (t.copyBg || 'Copy') : (t.copy || 'Copy form');
          h.after(btn);
          btn.addEventListener('click', function () {
            var txt = [], n = btn.nextElementSibling;
            while (n && n.tagName !== 'H2') { txt.push(n.innerText); n = n.nextElementSibling; }
            var done = function () { var o = btn.textContent; btn.textContent = bg ? (t.copiedBg || 'OK') : (t.copied || 'Copied'); setTimeout(function () { btn.textContent = o; }, 1500); };
            if (navigator.clipboard) navigator.clipboard.writeText(txt.join('\n')).then(done, done); else done();
          });
        }
      });
      layout.appendChild(nav);
      var links = Array.prototype.slice.call(ol.querySelectorAll('a'));
      var spy = function () {
        var cur = spyPick(heads.map(function (h) { return h.getBoundingClientRect().top; }), 140);
        links.forEach(function (a, i) { a.classList.toggle('is-active', i === cur); });
      };
      window.addEventListener('scroll', spy, { passive: true });
      setTimeout(spy, 50);
    }
    while (rte.firstChild) main.appendChild(rte.firstChild);
    layout.appendChild(main);
    rte.appendChild(layout);
    // e-mail and phone lines become buttons
    main.querySelectorAll('a[href^="mailto:"], a[href^="tel:"]').forEach(function (a) { a.classList.add('lm-pill'); });
  }

  /* ---------- About page: social tabs (click + arrow keys) ---------- */
  function initSocial() {
    document.querySelectorAll('[data-lm-social]').forEach(function (box) {
      if (box.dataset.lmOn) return;
      box.dataset.lmOn = '1';
      var tabs = Array.prototype.slice.call(box.querySelectorAll('[role="tab"]'));
      var pick = function (tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var p = document.getElementById(t.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
        if (focus) tab.focus();
      };
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { pick(t); });
        t.addEventListener('keydown', function (e) {
          var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : null;
          if (n === null) return;
          e.preventDefault();
          pick(tabs[(n + tabs.length) % tabs.length], true);
        });
      });
    });
  }

  /* ---------- category landing: "from" prices + Daylight / UV switch ---------- */
  function initCategory() {
    var box = document.querySelector('[data-lm-cat]');
    if (!box) return;
    // cheapest in-stock price per collection, from templates/collection.lmmin.liquid
    var cache = {};
    function lookup(url) {
      if (!cache[url]) {
        cache[url] = fetch(url + '?view=lmmin&sort_by=price-ascending&filter.v.availability=1', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      }
      return cache[url];
    }
    function fill(el) {
      lookup(el.getAttribute('data-lm-min')).then(function (d) {
        if (!d || !d.min) return;
        el.textContent = el.getAttribute('data-lm-min-label') + ' ' + d.min;
        el.hidden = false;
      });
    }
    // hidden spans have no box, so watch their visible parent
    var els = Array.prototype.slice.call(box.querySelectorAll('[data-lm-min]'));
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.unobserve(en.target);
          var el = en.target.querySelector('[data-lm-min]');
          if (el) fill(el);
        });
      }, { rootMargin: '300px 0px' });
      els.forEach(function (el) { io.observe(el.parentNode); });
    } else {
      els.forEach(fill);
    }
    // Daylight / UV: see initUv (shared with the collection page)
  }

  /* ---------- Daylight / 365 / 310 / 255 nm photo tabs (snippets/lm-uv-tabs) ----------
     The mode lives on [data-lm-uvwrap] (outside the part the collection filters re-render),
     so it survives filtering; the buttons are re-synced after each swap. */
  function syncUv(wrap) {
    var mode = wrap.getAttribute('data-lm-uvmode') || 'day';
    wrap.querySelectorAll('[data-lm-uv]').forEach(function (x) {
      x.setAttribute('aria-pressed', x.getAttribute('data-lm-uv') === mode ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lm-uv]');
    if (!b) return;
    var wrap = b.closest('[data-lm-uvwrap]');
    if (!wrap) return;
    var mode = b.getAttribute('data-lm-uv');
    if (mode === 'day') wrap.removeAttribute('data-lm-uvmode'); else wrap.setAttribute('data-lm-uvmode', mode);
    syncUv(wrap);
  });
  function initUv() {
    document.querySelectorAll('[data-lm-uvwrap]').forEach(function (wrap) {
      syncUv(wrap);
      new MutationObserver(function () { syncUv(wrap); }).observe(wrap, { childList: true, subtree: true });
    });
  }

  /* ---------- UV collection (lm-collection on uv_collections, snippets/lm-uv-picker, lm-card uvx) ----------
     - photo buttons on a card swap its photo in place (data-view on the card, CSS shows that photo)
     - glow colour chips filter the cards of this page (data-glow on the card = its colour(s) for this view)
     - a UV view is one server page of every match; uvPages shows per_page of them at a time (?uvp=N)
     - the Daylight view fetches the picker's UV counts from templates/collection.lmuvn.liquid */
  document.addEventListener('click', function (e) {
    var cv = e.target.closest('[data-lm-cardview]');
    if (cv) {
      var card = cv.closest('.lm-card--uvx');
      var v = cv.getAttribute('data-lm-cardview');
      card.setAttribute('data-view', v);
      card.querySelectorAll('[data-lm-cardview]').forEach(function (b) { b.setAttribute('aria-pressed', b === cv ? 'true' : 'false'); });
      var tag = card.querySelector('[data-lm-wtag]');
      // glow line: the selected pill's colour and wavelength; Day restores the line the card opened with
      var gl = card.querySelector('[data-lm-glowline]');
      if (gl) {
        var gt = gl.querySelector('[data-lm-glowtext]'), gd = gl.querySelector('.lm-gdot');
        var gm = gl.querySelector('.lm-gmeter');
        if (!gl.hasAttribute('data-orig')) { gl.setAttribute('data-orig', gt.textContent); gl.setAttribute('data-orig-g', gd.getAttribute('data-g') || ''); gl.setAttribute('data-orig-s', gm ? gm.getAttribute('data-s') : ''); }
        var pg = v === 'day' ? null : cv.getAttribute('data-gtext');
        if (v !== 'day' && !pg) { gl.hidden = true; }  // no known glow under this wavelength
        else {
          gt.textContent = pg || gl.getAttribute('data-orig');
          gd.setAttribute('data-g', pg ? cv.getAttribute('data-g') : gl.getAttribute('data-orig-g'));
          if (gm) gm.setAttribute('data-s', pg ? (cv.getAttribute('data-s') || '') : gl.getAttribute('data-orig-s'));
          gl.hidden = !gt.textContent;
        }
      }
      if (tag) tag.textContent = v === 'day' ? tag.getAttribute('data-day') : v + ' nm' + (card.classList.contains('lm-np-' + v) ? ' · ' + tag.getAttribute('data-np') : '');
      return;
    }
    var gc = e.target.closest('[data-lm-glow]');
    if (gc) {
      gc.setAttribute('aria-pressed', gc.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      applyGlow();
      return;
    }
    if (e.target.closest('[data-lm-glowclear]')) {
      document.querySelectorAll('[data-lm-glow]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      applyGlow();
      return;
    }
    var cp = e.target.closest('[data-lm-cpage-go]');
    if (cp) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      uvPages(+cp.getAttribute('data-lm-cpage-go'), true);
    }
  });
  function applyGlow() {
    var root = collRoot();
    if (!root) return;
    var on = [];
    root.querySelectorAll('[data-lm-glow][aria-pressed="true"]').forEach(function (b) { on.push(b.getAttribute('data-lm-glow')); });
    var n = 0;
    root.querySelectorAll('.lm-grid--coll > li').forEach(function (li) {
      var card = li.querySelector('.lm-card--uvx');
      var g = card ? card.getAttribute('data-glow') || '' : '';
      var show = !on.length || on.some(function (k) { return g.indexOf(' ' + k + ' ') > -1; });
      li.toggleAttribute('data-lm-gout', !show);
      if (show && card) n++;
    });
    uvPages(1);
    var empty = root.querySelector('[data-lm-glowempty]');
    if (empty) empty.hidden = !(on.length && n === 0);
    var cnt = root.querySelector('[data-lm-gcount]');
    if (cnt && !cnt.hasAttribute('data-all')) cnt.setAttribute('data-all', cnt.textContent);
    if (cnt && on.length) cnt.textContent = n === 1 ? cnt.getAttribute('data-one') : cnt.getAttribute('data-other').replace('__N__', n);
    else if (cnt && cnt.hasAttribute('data-all')) cnt.textContent = cnt.getAttribute('data-all');
  }
  function uvPages(page, scroll) {
    var root = collRoot();
    var grid = root && root.querySelector('[data-lm-cpage]');
    var nav = root && root.querySelector('[data-lm-cpages]');
    if (!grid || !nav) return;
    var per = +grid.getAttribute('data-lm-cpage') || 24;
    var all = Array.prototype.slice.call(grid.children);
    var lis = all.filter(function (li) { return !li.hasAttribute('data-lm-gout'); });
    var pages = Math.max(1, Math.ceil(lis.length / per));
    page = Math.min(Math.max(1, page || 1), pages);
    all.forEach(function (li) { li.hidden = true; });
    lis.forEach(function (li, i) { li.hidden = Math.floor(i / per) + 1 !== page; });
    function href(n) {
      var u = new URL(location.href);
      if (n > 1) u.searchParams.set('uvp', n); else u.searchParams.delete('uvp');
      return u.toString();
    }
    if (href(page) !== location.href) history.replaceState(history.state, '', href(page));
    function link(n, cls, label) {
      var a = document.createElement('a');
      a.className = cls; a.href = href(n); a.setAttribute('data-lm-cpage-go', n); a.textContent = label;
      return a;
    }
    nav.textContent = '';
    nav.hidden = pages < 2;
    if (page > 1) nav.appendChild(link(page - 1, 'lm-pages__nav', nav.getAttribute('data-prev')));
    var last = 0;
    for (var n = 1; n <= pages; n++) {
      if (n !== 1 && n !== pages && Math.abs(n - page) > 2) continue;
      if (last && n - last > 1) { var gap = document.createElement('span'); gap.className = 'lm-pages__gap'; gap.textContent = '…'; nav.appendChild(gap); }
      if (n === page) {
        var cur = document.createElement('span');
        cur.className = 'lm-pages__n is-current'; cur.setAttribute('aria-current', 'page'); cur.textContent = n;
        nav.appendChild(cur);
      } else nav.appendChild(link(n, 'lm-pages__n', n));
      last = n;
    }
    if (page < pages) nav.appendChild(link(page + 1, 'lm-pages__nav', nav.getAttribute('data-next')));
    if (scroll) {
      var y = root.querySelector('#ProductGridContainer').getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }
  function initUvPages() { uvPages(+new URL(location.href).searchParams.get('uvp') || 1); }
  document.addEventListener('lm:collection-updated', initUvPages);
  function initUvCounts() {
    var pick = document.getElementById('LmUvPick');
    if (!pick || !pick.querySelector('[data-lm-uvcount]')) return;
    var u = new URL(location.href);
    u.searchParams.set('view', 'lmuvn');
    u.searchParams.delete('page');
    u.searchParams.delete('section_id');
    fetch(u.toString())
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d) return;
        pick.querySelectorAll('[data-lm-uvn]').forEach(function (el) {
          var k = el.getAttribute('data-lm-uvn');
          if (el.textContent.trim() === '' && d[k] != null) el.textContent = d[k];
        });
      })
      .catch(function () {});
  }
  document.addEventListener('lm:collection-updated', initUvCounts);

  /* ---------- 404 page (sections/lm-404.liquid) ----------
     "Try:" chips fill the search box; on a sold-product link the similar stones are ordered by size
     (URL "5-4x4-2mm" vs each card title "5.4x4.2mm", first dimension) and tagged Same size (±0.2mm) /
     Close in size (±0.8mm); "Report this link" posts the URL + referrer through the contact form. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-lm-404try]');
    if (t) {
      var inp = document.getElementById('Lm404Q');
      if (inp) { inp.value = t.getAttribute('data-lm-404try'); inp.focus(); }
      return;
    }
    var send = e.target.closest('[data-lm-404send]');
    if (send) {
      var card = send.closest('[data-lm-404report]');
      var fd = new FormData();
      fd.append('form_type', 'contact');
      fd.append('utf8', '\u2713');
      fd.append('contact[email]', card.getAttribute('data-email'));
      fd.append('contact[name]', 'Broken link report (404 page)');
      fd.append('contact[body]', 'Broken link: ' + location.href + '\nCame from: ' + (document.referrer || '(none)'));
      send.disabled = true;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'contact', { method: 'POST', body: fd })
        .then(function (r) {
          var ok = r.ok && r.url.indexOf('challenge') === -1;
          send.hidden = true;
          card.querySelector(ok ? '[data-lm-404done]' : '[data-lm-404fail]').hidden = false;
        })
        .catch(function () { send.hidden = true; card.querySelector('[data-lm-404fail]').hidden = false; });
    }
  });
  function init404() {
    var hero = document.querySelector('[data-lm-404hero]');
    if (!hero) return;
    var pm = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!pm) return;
    var handle = decodeURIComponent(pm[1]).toLowerCase();
    // sold texts
    hero.querySelector('[data-lm-404eyebrow]').textContent = hero.getAttribute('data-sold-eyebrow');
    hero.querySelector('[data-lm-404title]').textContent = hero.getAttribute('data-sold-title');
    hero.querySelector('[data-lm-404body]').textContent = hero.getAttribute('data-sold-body');
    // stone: longest collection handle contained in the product handle
    var stones = [];
    try { stones = JSON.parse(document.getElementById('Lm404Stones').textContent); } catch (err) {}
    var best = null;
    stones.forEach(function (st) {
      var h = st.h, hs = h.replace(/s$/, '');
      if ((handle.indexOf(h) > -1 || handle.indexOf(hs) > -1) && (!best || h.length > best.h.length)) best = st;
    });
    if (!best) return;
    var tries = hero.querySelector('[data-lm-404tries]');
    if (tries) {
      tries.querySelectorAll('[data-lm-404try]').forEach(function (b, i) {
        if (i === 0) { b.textContent = best.n.toLowerCase(); b.setAttribute('data-lm-404try', best.n.toLowerCase()); } else b.remove();
      });
    }
    var grid = document.querySelector('[data-lm-404grid]');
    var list = grid.querySelector('[data-lm-404list]');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'collections/' + encodeURIComponent(best.h) + '?view=lm404')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html || html.indexOf('<li') === -1) return;
        list.innerHTML = html;
        grid.hidden = false;
        grid.querySelector('[data-lm-404gh]').textContent = grid.getAttribute('data-sim-title');
        var sub = grid.querySelector('[data-lm-404gs]');
        sub.textContent = grid.getAttribute('data-sim-sub'); sub.hidden = false;
        var a = grid.querySelector('[data-lm-404ga]');
        if (a) { a.href = best.u; a.textContent = best.n + ': ' + grid.getAttribute('data-sim-all') + '\u00a0\u2192'; }
        // order by size: URL "5-4x4-2mm" = 5.4mm vs each card title, first dimension
        var m = handle.match(/(\d+(?:-\d+)?)(?:x\d+(?:-\d+)?)*mm/);
        var want = m ? parseFloat(m[1].replace('-', '.')) : null;
        // same colour first (colour word in the URL handle vs each card's product handle, both English)
        var COLS = ['padparadscha', 'blue', 'pink', 'yellow', 'green', 'purple', 'violet', 'orange', 'red', 'white', 'black', 'teal', 'champagne', 'colorless', 'grey', 'brown'];
        var col = null;
        COLS.some(function (c) { if (new RegExp('(^|-)' + c + '(-|$)').test(handle)) { col = c; return true; } return false; });
        var items = Array.prototype.slice.call(list.children).map(function (li, i) {
          var t = (li.querySelector('.lm-card__title') || li).textContent;
          var mm = t.match(/(\d+(?:\.\d+)?)\s*(?:x\s*\d+(?:\.\d+)?\s*)*mm/i);
          var a = li.querySelector('a[href*="/products/"]');
          var ph = a ? a.getAttribute('href').split('/products/')[1] || '' : '';
          var colOk = !col || new RegExp('(^|-)' + col + '(-|$)').test(ph);
          return { li: li, d: want != null && mm ? Math.abs(parseFloat(mm[1]) - want) : 99, c: colOk ? 0 : 1, i: i };
        });
        items.sort(function (x, y) { return x.c - y.c || x.d - y.d || x.i - y.i; });
        items.forEach(function (it, i) {
          list.appendChild(it.li);
          it.li.hidden = i >= 4;
          if (i < 4 && it.d <= 0.8) {
            var badges = it.li.querySelector('.lm-card__badges');
            if (badges) {
              var b = document.createElement('span');
              b.className = 'lm-badge lm-badge--size';
              b.textContent = it.d <= 0.2 ? grid.getAttribute('data-same') : grid.getAttribute('data-close');
              badges.appendChild(b);
            }
          }
        });
      })
      .catch(function () {});
  }

  /* ---------- All collections page (sections/lm-collections.liquid) ----------
     By category / A-Z views. Category chips and A-Z letters FILTER (show only that group or
     letter, no scrolling); "All" resets. The search box filters by name in both views. */
  function initCollections() {
    var root = document.querySelector('[data-lm-cols]');
    if (!root) return;
    var cat = root.querySelector('[data-lm-cols-cat]');
    var az = root.querySelector('[data-lm-cols-az]');
    var groups = [].slice.call(root.querySelectorAll('[data-lm-cols-group]'));
    var allLabel = az.dataset.all;
    var loc = az.dataset.locale || 'en';
    var st = { view: 'cat', group: null, letter: null, q: '' };

    // unique collections for the intro count and the A-Z list
    var seen = {}, items = [];
    root.querySelectorAll('.lm-cols__item').forEach(function (li) {
      if (seen[li.dataset.url]) return;
      seen[li.dataset.url] = 1;
      var name = li.dataset.name.trim();
      items.push({ name: name, url: li.dataset.url, n: li.dataset.n, letter: name.charAt(0).toLocaleUpperCase(loc) });
    });
    items.sort(function (a, b) { return a.name.localeCompare(b.name, loc); });
    var intro = root.querySelector('[data-lm-cols-intro]');
    intro.textContent = intro.dataset.tpl.replace('{n}', items.length);
    intro.hidden = false;
    root.querySelector('[data-lm-cols-views]').hidden = false;

    function chipBtn(label, n, key, attr) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lm-cols__chip';
      b.setAttribute(attr, key);
      b.setAttribute('aria-pressed', 'false');
      b.appendChild(document.createTextNode(label));
      if (n !== '') { var sp = document.createElement('span'); sp.textContent = n; b.appendChild(sp); }
      return b;
    }
    // category chips
    var jump = root.querySelector('[data-lm-cols-jump]');
    jump.appendChild(chipBtn(allLabel, '', '', 'data-lm-cols-g'));
    groups.forEach(function (g, i) { jump.appendChild(chipBtn(g.dataset.title, g.querySelectorAll('.lm-cols__item').length, String(i), 'data-lm-cols-g')); });
    // A-Z
    var letters = [], byL = {};
    items.forEach(function (it) { if (!byL[it.letter]) { byL[it.letter] = []; letters.push(it.letter); } byL[it.letter].push(it); });
    var lnav = root.querySelector('[data-lm-cols-letters]');
    var lall = chipBtn(allLabel, '', '', 'data-lm-cols-l'); lall.classList.add('lm-cols__letter--all'); lnav.appendChild(lall);
    var list = root.querySelector('[data-lm-cols-azlist]');
    letters.forEach(function (L) {
      var b = chipBtn(L, '', L, 'data-lm-cols-l'); b.classList.add('lm-cols__letter'); lnav.appendChild(b);
      var sec = document.createElement('section');
      sec.className = 'lm-cols__azsec';
      sec.dataset.letter = L;
      var h = document.createElement('h2'); h.className = 'lm-cols__azh'; h.textContent = L; sec.appendChild(h);
      byL[L].forEach(function (it) {
        var a = document.createElement('a');
        a.className = 'lm-cols__row'; a.href = it.url; a.dataset.name = it.name;
        var s1 = document.createElement('span'); s1.textContent = it.name;
        var s2 = document.createElement('span'); s2.className = 'lm-cols__n'; s2.textContent = it.n;
        a.appendChild(s1); a.appendChild(s2); sec.appendChild(a);
      });
      list.appendChild(sec);
    });

    var input = root.querySelector('[data-lm-cols-find]');
    var clear = root.querySelector('[data-lm-cols-clear]');
    var none = root.querySelector('[data-lm-cols-none]');
    function match(name) { return !st.q || name.toLocaleLowerCase(loc).indexOf(st.q) > -1; }
    function render() {
      cat.hidden = st.view !== 'cat';
      az.hidden = st.view !== 'az';
      root.querySelectorAll('[data-lm-cols-view]').forEach(function (b) { b.setAttribute('aria-selected', b.dataset.lmColsView === st.view ? 'true' : 'false'); });
      var any = 0;
      // category view
      groups.forEach(function (g, i) {
        var vis = 0;
        g.querySelectorAll('.lm-cols__item').forEach(function (li) { var ok = match(li.dataset.name); li.hidden = !ok; if (ok) vis++; });
        g.querySelector('[data-lm-cols-gn]').textContent = vis;
        g.hidden = !vis || (st.group !== null && String(i) !== st.group);
        if (st.view === 'cat' && !g.hidden) any += vis;
      });
      jump.querySelectorAll('[data-lm-cols-g]').forEach(function (b) { b.setAttribute('aria-pressed', (b.getAttribute('data-lm-cols-g') || null) === st.group ? 'true' : 'false'); });
      // A-Z view
      list.querySelectorAll('.lm-cols__azsec').forEach(function (sec) {
        var vis = 0;
        sec.querySelectorAll('.lm-cols__row').forEach(function (a) { var ok = match(a.dataset.name); a.hidden = !ok; if (ok) vis++; });
        sec.hidden = !vis || (st.letter !== null && sec.dataset.letter !== st.letter);
        var lb = lnav.querySelector('[data-lm-cols-l="' + sec.dataset.letter + '"]');
        if (lb) lb.disabled = !vis;
        if (st.view === 'az' && !sec.hidden) any += vis;
      });
      lnav.querySelectorAll('[data-lm-cols-l]').forEach(function (b) { b.setAttribute('aria-pressed', (b.getAttribute('data-lm-cols-l') || null) === st.letter ? 'true' : 'false'); });
      // nothing found
      none.hidden = any > 0;
      if (!any) {
        var q = input.value.trim();
        var t = none.querySelector('span'), a = none.querySelector('[data-lm-cols-searchall]');
        t.textContent = t.dataset.tpl.replace('{q}', q);
        a.textContent = a.dataset.tpl.replace('{q}', q);
        a.href = a.getAttribute('href').split('?')[0] + '?q=' + encodeURIComponent(q);
      }
      clear.hidden = !input.value;
    }
    root.addEventListener('click', function (e) {
      var v = e.target.closest('[data-lm-cols-view]');
      if (v) { st.view = v.dataset.lmColsView; render(); return; }
      var g = e.target.closest('[data-lm-cols-g]');
      if (g) { st.group = g.getAttribute('data-lm-cols-g') || null; render(); return; }
      var l = e.target.closest('[data-lm-cols-l]');
      if (l && !l.disabled) { st.letter = l.getAttribute('data-lm-cols-l') || null; render(); return; }
      if (e.target.closest('[data-lm-cols-clear]')) { input.value = ''; st.q = ''; render(); input.focus(); }
    });
    input.addEventListener('input', function () {
      st.q = input.value.trim().toLocaleLowerCase(loc);
      st.group = null; st.letter = null;
      render();
    });
    render();
  }

  /* ---------- Search page (sections/lm-search.liquid) ----------
     Type-tab counts (templates/search.lmcount.liquid), the matches row (predictive search ->
     sections/lm-search-matches.liquid), filters that reload on change, sort, clear button. */
  function initSearchPage() {
    var root = document.querySelector('[data-lm-srch]');
    if (!root) return;
    var base = root.dataset.base, cur = root.dataset.type;
    root.querySelectorAll('[data-lm-srch-tab]').forEach(function (a) {
      var t = a.getAttribute('data-lm-srch-tab');
      if (t === cur) return;
      fetch(base + '&type=' + t + '&view=lmcount', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (txt) {
          var n = parseInt(txt, 10) || 0;
          a.querySelector('[data-lm-srch-n]').textContent = n;
          if (n > 0) a.hidden = false;
        }).catch(function () {});
    });
    var box = root.querySelector('[data-lm-srch-matches]');
    var q = root.dataset.q;
    if (box && q) {
      var sugg = base.split('?')[0].replace(/\/$/, '') + '/suggest?q=' + encodeURIComponent(q) +
        '&resources[type]=article,collection&resources[limit]=6&section_id=lm-search-matches';
      fetch(sugg, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var m = doc.querySelector('[data-lm-srchm]');
          if (!m || !m.querySelector('a')) return;
          box.innerHTML = '';
          box.appendChild(m);
          box.hidden = false;
        }).catch(function () {});
    }
    var form = root.querySelector('[data-lm-srch-filters]');
    // In stock only = options[unavailable_products]=hide
    var hideNow = new URL(location.href).searchParams.get('options[unavailable_products]') === 'hide';
    var stock = root.querySelector('[data-lm-srch-stock]'), unav = root.querySelector('[data-lm-srch-unav]');
    if (stock && unav) {
      stock.checked = hideNow;
      unav.value = hideNow ? 'hide' : 'show';
      stock.addEventListener('change', function () { unav.value = stock.checked ? 'hide' : 'show'; });
    }
    var chip = root.querySelector('[data-lm-srch-stockchip]');
    if (chip && hideNow) {
      var cu = new URL(location.href);
      cu.searchParams.set('options[unavailable_products]', 'show');
      cu.searchParams.delete('page');
      chip.href = cu.toString();
      chip.hidden = false;
    }
    if (form) {
      form.addEventListener('change', function () {
        // drop empty price fields so they do not become filters
        form.querySelectorAll('input[type=number]').forEach(function (i) { i.disabled = i.value === ''; });
        form.submit();
      });
    }
    var sort = root.querySelector('[data-lm-srch-sort]');
    if (sort) sort.addEventListener('change', function () {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', sort.value);
      u.searchParams.delete('page');
      location.href = u.toString();
    });
    var input = root.querySelector('[data-lm-srch-q]'), clr = root.querySelector('[data-lm-srch-clear]');
    if (input && clr) {
      input.addEventListener('input', function () { clr.hidden = !input.value; });
      clr.addEventListener('click', function () { input.value = ''; clr.hidden = true; input.focus(); });
    }
  }

  /* ---------- Predictive search in the header (sections/lm-header.liquid, lm-predictive.liquid) ----------
     Focus opens the panel: recent searches (localStorage 'lm-recent', last 5 submitted), popular chips,
     browse links. Typing loads sections/lm-predictive via the predictive search API. Keyboard: arrows
     move through suggestions -> collections -> products -> guides -> see all, Enter opens, Esc closes.
     Under 750px the open search is a full-screen panel (CSS) with Cancel. */
  function initPredictive() {
    var root = document.querySelector('[data-lm-ps]');
    if (!root) return;
    var form = root.querySelector('form'), input = root.querySelector('[data-ps-input]');
    var panel = root.querySelector('[data-ps-panel]'), live = root.querySelector('[data-ps-live]');
    var start = root.querySelector('[data-ps-start]'), backdrop = root.querySelector('.lm-ps-backdrop');
    var clear = root.querySelector('[data-ps-clear]');
    var url = root.dataset.url, timer = null, ctrl = null, active = -1, isOpen = false;
    var mqMobile = window.matchMedia('(max-width: 749px)');
    var KEY = 'lm-recent';
    function getRecent() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
    function setRecent(a) { try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, 5))); } catch (e) {} }
    function renderRecent() {
      var box = root.querySelector('[data-ps-recent]'); if (!box) return;
      var list = getRecent();
      box.innerHTML = '';
      list.forEach(function (q, i) {
        var row = document.createElement('div'); row.className = 'lm-ps__ritem';
        var go = document.createElement('button'); go.type = 'button'; go.className = 'lm-ps__rgo'; go.setAttribute('data-ps-go', q);
        go.innerHTML = '<span aria-hidden="true">↺</span><span></span>'; go.lastChild.textContent = q;
        var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'lm-ps__rrm'; rm.setAttribute('data-ps-rm', i);
        rm.setAttribute('aria-label', box.dataset.remove + ': ' + q); rm.textContent = '×';
        row.appendChild(go); row.appendChild(rm); box.appendChild(row);
      });
      root.querySelector('[data-ps-recent-none]').hidden = list.length > 0;
      root.querySelector('[data-ps-recent-clear]').hidden = list.length === 0;
    }
    function open() {
      if (isOpen) return;
      isOpen = true;
      renderRecent();
      panel.hidden = false; backdrop.hidden = false;
      root.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
      if (mqMobile.matches) document.documentElement.classList.add('lm-ps-lock');
    }
    function close() {
      if (!isOpen) return;
      isOpen = false;
      panel.hidden = true; backdrop.hidden = true;
      root.classList.remove('is-open');
      input.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('lm-ps-lock');
      setActive(-1);
    }
    function items() {
      var all = [].slice.call(panel.querySelectorAll('[data-ps-item]')).filter(function (el) { return el.offsetParent !== null; });
      return all.map(function (el, i) { return { el: el, o: +(el.dataset.psOrder || 9), i: i }; })
        .sort(function (a, b) { return a.o - b.o || a.i - b.i; }).map(function (x) { return x.el; });
    }
    function setActive(n) {
      var list = items();
      list.forEach(function (el, i) { var on = i === n; el.classList.toggle('is-active', on); if (el.hasAttribute('aria-selected')) el.setAttribute('aria-selected', on ? 'true' : 'false'); });
      active = n;
      if (n >= 0 && list[n]) list[n].scrollIntoView({ block: 'nearest' });
    }
    function showStart() { live.innerHTML = ''; if (start) start.hidden = false; setActive(-1); }
    function load() {
      var q = input.value.trim();
      clear.hidden = !input.value;
      if (!q) { showStart(); return; }
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var u = url + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query,article,page' +
        '&resources[limit]=5&resources[limit_scope]=each&section_id=lm-predictive';
      fetch(u, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (input.value.trim() !== q) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var res = doc.querySelector('[data-ps-results]');
          if (!res) return;
          live.innerHTML = '';
          live.appendChild(res);
          if (start) start.hidden = true;
          setActive(-1);
        }).catch(function () {});
    }
    function go(q) { input.value = q; if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
    function fill(q) { input.value = q; input.focus(); load(); }
    function activate(el) {
      if (el.hasAttribute('data-ps-fill')) fill(el.getAttribute('data-ps-fill'));
      else if (el.hasAttribute('data-ps-go')) go(el.getAttribute('data-ps-go'));
      else if (el.type === 'submit') { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
      else if (el.href) location.href = el.href;
    }
    input.addEventListener('focus', open);
    input.addEventListener('click', open);
    input.addEventListener('input', function () { open(); clearTimeout(timer); timer = setTimeout(load, 180); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); input.blur(); return; }
      if (!isOpen) return;
      var list = items();
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(list.length ? (active + 1) % list.length : -1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(list.length ? (active <= 0 ? list.length - 1 : active - 1) : -1); }
      else if (e.key === 'Enter' && active >= 0 && list[active]) { e.preventDefault(); activate(list[active]); }
    });
    panel.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-ps-rm]');
      if (rm) { e.preventDefault(); var l = getRecent(); l.splice(+rm.getAttribute('data-ps-rm'), 1); setRecent(l); renderRecent(); input.focus(); return; }
      if (e.target.closest('[data-ps-recent-clear]')) { setRecent([]); renderRecent(); input.focus(); return; }
      var f = e.target.closest('[data-ps-fill]'); if (f) { e.preventDefault(); fill(f.getAttribute('data-ps-fill')); return; }
      var g = e.target.closest('[data-ps-go]'); if (g) { e.preventDefault(); go(g.getAttribute('data-ps-go')); }
    });
    panel.addEventListener('mousemove', function (e) {
      var it = e.target.closest('[data-ps-item]'); if (!it) return;
      var n = items().indexOf(it); if (n !== active) setActive(n);
    });
    root.addEventListener('click', function (e) { if (e.target.closest('[data-ps-close]')) { e.preventDefault(); close(); } });
    document.addEventListener('click', function (e) { if (isOpen && !root.contains(e.target)) close(); });
    clear.addEventListener('click', function () { input.value = ''; clear.hidden = true; showStart(); input.focus(); });
    // remember submitted searches (raw text, before exact-search adds quotes)
    form.addEventListener('submit', function () {
      var q = input.value.replace(/"/g, '').trim();
      if (!q) return;
      var l = getRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      l.unshift(q); setRecent(l);
    });
    clear.hidden = !input.value;
  }

  /* ---------- Zodiac page (sections/lm-zodiac.liquid) ----------
     Sign buttons (wheel on desktop, row on mobile) show one of the 12 server-rendered panels;
     the element filter fades other signs; the finder maps a day + month to the sign and the
     month's birthstones (data from the JSON script tag; nothing is stored). */
  function initZodiac() {
    var root = document.querySelector('[data-lm-zw]');
    if (!root) return;
    var btns = [].slice.call(root.querySelectorAll('[data-zw-sign]'));
    var order = btns.map(function (b) { return b.getAttribute('data-zw-sign'); });
    var cur = root.dataset.cur || order[0];
    function pick(h, scroll) {
      cur = h;
      btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-zw-sign') === h ? 'true' : 'false'); });
      root.querySelectorAll('[data-zw-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-zw-panel') !== h; });
      var b = btns[order.indexOf(h)];
      if (b) {
        root.setAttribute('data-cur-el', b.dataset.el);
        root.querySelector('[data-zw-csym]').textContent = b.dataset.sym;
        root.querySelector('[data-zw-cname]').textContent = b.dataset.name;
        root.querySelector('[data-zw-cdates]').textContent = b.dataset.dates;
        if (b.scrollIntoView && window.matchMedia('(max-width: 899px)').matches) b.scrollIntoView({ block: 'nearest', inline: 'center' });
      }
      if (scroll) root.querySelector('#signs').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-zw-sign]');
      if (b) { pick(b.getAttribute('data-zw-sign')); return; }
      var st = e.target.closest('[data-zw-step]');
      if (st) { var i = order.indexOf(cur) + parseInt(st.getAttribute('data-zw-step'), 10); pick(order[(i + 12) % 12]); return; }
      var el = e.target.closest('[data-zw-el]');
      if (el) {
        var v = el.getAttribute('data-zw-el');
        root.querySelectorAll('[data-zw-el]').forEach(function (x) { x.setAttribute('aria-pressed', x === el ? 'true' : 'false'); });
        btns.forEach(function (x) { x.classList.toggle('is-faded', !!v && x.dataset.el !== v); });
        return;
      }
      var see = e.target.closest('[data-zw-see]');
      if (see) pick(see.getAttribute('data-zw-see'), true);
    });
    pick(cur);

    // finder
    var data = {};
    try { data = JSON.parse(root.querySelector('[data-zw-data]').textContent); } catch (err) { return; }
    var dSel = root.querySelector('[data-zw-day]'), mSel = root.querySelector('[data-zw-month]');
    var res = root.querySelector('[data-zw-res]'), hint = root.querySelector('[data-zw-hint]');
    function pills(box, list) {
      box.innerHTML = '';
      list.forEach(function (s) {
        var el = document.createElement(s.u ? 'a' : 'span');
        el.className = 'lm-zw__fpill' + (s.u ? '' : ' is-off');
        if (s.u) el.href = s.u;
        el.textContent = s.n;
        box.appendChild(el);
      });
    }
    function find() {
      var d = parseInt(dSel.value, 10), m = parseInt(mSel.value, 10);
      if (!d || !m) { res.hidden = true; hint.hidden = false; return; }
      var md = m * 100 + d, sign = null;
      (data.signs || []).forEach(function (s) {
        if (s.from <= s.to ? (md >= s.from && md <= s.to) : (md >= s.from || md <= s.to)) sign = s;
      });
      var month = (data.months || []).filter(function (x) { return x.m === m; })[0];
      if (!sign) { res.hidden = true; return; }
      root.querySelector('[data-zw-rsym]').textContent = sign.sym + '\uFE0E';
      root.querySelector('[data-zw-rname]').textContent = sign.name;
      root.querySelector('[data-zw-rdates]').textContent = sign.dates;
      root.querySelector('[data-zw-rl1]').textContent = res.dataset.lSign;
      pills(root.querySelector('[data-zw-rsign]'), sign.stones);
      root.querySelector('[data-zw-rl2]').textContent = res.dataset.lMonth.replace('{month}', month ? month.name.toUpperCase() : '');
      pills(root.querySelector('[data-zw-rmonth]'), month ? month.stones : []);
      var see = root.querySelector('[data-zw-see]');
      see.setAttribute('data-zw-see', sign.h);
      see.textContent = res.dataset.lSee.replace('{name}', sign.name) + ' \u2193';
      res.hidden = false; hint.hidden = true;
    }
    dSel.addEventListener('change', find);
    mSel.addEventListener('change', find);
  }

  function init() {
    syncThemeLabels();
    initMega();
    initDrawer();
    initSearch();
    initShuffle();
    initRandom();
    initPolicy();
    initSocial();
    initWish();
    initCategory();
    initUv();
    initUvCounts();
    initUvPages();
    init404();
    initCollections();
    initSearchPage();
    initPredictive();
    initZodiac();
    initCurrency();
  }
  /* Shipping texts in the visitor's currency (Oct 19 2026). Shipping copy is written in euros (the snippets
     and the Shipping page text). In a converted currency (US market = USD) every euro amount inside
     [data-lm-cur] is converted with Shopify.currency.rate, the live rate Shopify uses for the product prices
     and the cart's free-shipping bar. Whole amounts are thresholds ("over €100") and are rounded UP to a whole
     unit, so the promise is never lower than the real discount minimum; amounts with cents are shipping rates
     and keep 2 decimals. Formats: "€6.99" (EN) and "6.99 €" (BG). */
  function initCurrency() {
    var cur = window.Shopify && window.Shopify.currency;
    if (!cur || !cur.active || cur.active === 'EUR') return;
    var rate = parseFloat(cur.rate);
    if (!(rate > 0)) return;
    var lang = document.documentElement.lang || 'en';
    var re = /€\s?(\d{1,6}(?:[.,]\d{1,2})?)|(\d{1,6}(?:[.,]\d{1,2})?)\s?€/g;
    function fmt(num) {
      var whole = !/[.,]\d/.test(num);
      var v = parseFloat(num.replace(',', '.')) * rate;
      if (whole) v = Math.ceil(v);
      var d = whole ? 0 : 2;
      try {
        return new Intl.NumberFormat(lang, { style: 'currency', currency: cur.active, currencyDisplay: 'narrowSymbol', minimumFractionDigits: d, maximumFractionDigits: d }).format(v);
      } catch (e) {
        return cur.active + ' ' + v.toFixed(d);
      }
    }
    document.querySelectorAll('[data-lm-cur]').forEach(function (el) {
      if (el.hasAttribute('data-lm-cur-done')) return;
      el.setAttribute('data-lm-cur-done', '');
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var nodes = [];
      var n;
      while ((n = walker.nextNode())) if (n.nodeValue.indexOf('€') > -1) nodes.push(n);
      nodes.forEach(function (t) {
        t.nodeValue = t.nodeValue.replace(re, function (m, a, b) { return fmt(a || b); });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Gemstone ID card (snippets/lm-gem-id): Daylight / UV buttons in the Fluorescence panel pick the main photo */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-gid-photo]'); if (!b) return;
  var card = b.closest('.lm-gid'), img = card && card.querySelector('.lm-gid__photo img'); if (!img) return;
  img.removeAttribute('srcset'); img.src = b.getAttribute('data-gid-photo');
  card.querySelectorAll('[data-gid-photo]').forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
});
/* Gemstone ID card QR code: links to the card's own page (/pages/gem-id). Needs assets/lm-qr.js (qrcode-generator, MIT),
   loaded by the account hub and the card page. Called again by those pages after they add a card. */
window.lmGidQR = function (scope) {
  if (!window.qrcode) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root || '/').replace(/\/$/, '');
  (scope || document).querySelectorAll('.lm-gid').forEach(function (c) {
    var box = c.querySelector('[data-gid-qr]'); if (!box || box.firstChild) return;
    var d = c.dataset;
    if (!d.gidH && !d.gidS) { box.parentNode.hidden = true; return; }
    var url = location.origin + root + '/pages/gem-id?p=' + (d.gidH || '') + '&s=' + (d.gidS || '') + (d.gidO ? '&o=' + d.gidO : '') + (d.gidD ? '&d=' + d.gidD : '');
    try { var q = qrcode(0, 'M'); q.addData(url); q.make(); box.innerHTML = q.createSvgTag({ cellSize: 2, margin: 0, scalable: true }); }
    catch (err) { box.parentNode.hidden = true; }
  });
};
document.addEventListener('DOMContentLoaded', function () { window.lmGidQR(); });
window.addEventListener('load', function () { window.lmGidQR(); });
